import { Button, Flex } from '@chakra-ui/react';
import MediaForm from '@components/app/form/MediaForm';
import { FieldArray } from 'formik';
import uniqid from 'uniqid';

interface MediasFormProps {
  name: string;
  readOnlyCollection?: boolean;
  variant?: string;
  medias: any[];
  isDisabled?: boolean;
  withAlt?: boolean;
  addingButtonLabel?: string;
  showOnlyMediaTab?: 'fileMedia' | 'soundMedia' | 'linkMedia' | 'videoMedia';
}

export default function MediasForm({
  name,
  medias,
  variant = 'brand',
  readOnlyCollection = false,
  isDisabled = false,
  withAlt = false,
  addingButtonLabel = 'Ajouter un autre lien ou fichier',
  showOnlyMediaTab,
}: MediasFormProps) {
  return (
    <FieldArray name={name}>
      {arrayHelpers => {
        return (
          <>
            <Flex direction="column" gap={['0.5rem', '', '1rem']}>
              {medias.map((media, index) => (
                <MediaForm
                  key={media.id ? media.id : media.collectionId}
                  media={media}
                  name={`${name}.${index}`}
                  onMediaRemove={
                    !readOnlyCollection && (() => arrayHelpers.remove(index))
                  }
                  isDisabled={isDisabled}
                  withAlt={withAlt}
                  showOnlyMediaTab={showOnlyMediaTab}
                />
              ))}

              {!readOnlyCollection && (
                <Flex justify="end">
                  <Button
                    variant={variant}
                    size={['xs', 'sm']}
                    width="fit-content"
                    onClick={evt => {
                      evt.preventDefault();

                      arrayHelpers.push({
                        __TYPE__: showOnlyMediaTab
                          ? showOnlyMediaTab
                          : 'fileMedia',
                        collectionId: uniqid(),
                        file: {
                          uploading: false,
                          uploaded: false,
                          uploadId: null,
                          fileName: null,
                        },
                        description: '',
                        title: '',
                      });
                    }}
                    isDisabled={isDisabled}
                  >
                    {addingButtonLabel}
                  </Button>
                </Flex>
              )}
            </Flex>
          </>
        );
      }}
    </FieldArray>
  );
}
